export default __webpack_public_path__ + "media/images/open-graph-image-34a080669a55ce08512e324b70f1308a.jpg";